import { IMessage } from '@eventr/common'
import { ColoursObj, Icon } from '@eventr/common-storybook'
import { useImageFrameStore } from '../../../../state/overlayState/MobileImageFrame'
import { defaultAddSnack } from '../../../../state/overlayState/overlayContext'
import { useChatBodyContext } from '../chatProvider'

interface IImageTypeMessageProps {
    message: IMessage
}
export function ImageTypeMessage({ message }: IImageTypeMessageProps) {
    const { api, getDownloadUrl } = useChatBodyContext()

    if (api?.value?.chatApi) {
        return (
            <img
                width={'234px'}
                loading="lazy"
                src={getDownloadUrl?.(
                    api.value.chatApi.host + message.attachments[0].image_url
                )}
                alt=""
                onClick={() => {
                    const imageUrl =
                        getDownloadUrl?.(
                            api?.value?.chatApi.host +
                                message.attachments[0].image_url
                        ) ?? ''
                    useImageFrameStore.getState().openImageFrame(imageUrl)
                }}
            />
        )
    } else {
        return (
            <div
                style={{
                    backgroundColor: ColoursObj.shades.shade4,
                    height: '50px',
                    width: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '8px',
                }}
                onClick={() => {
                    defaultAddSnack(
                        'Could not display image, please try again later',
                        'warning'
                    )
                }}
            >
                <Icon name="Important" />
            </div>
        )
    }
}
